export const MOISTURE_CONTENT_FIELDS = [
  "moisture_content",
  "moisture_content_mean",
  "moisture_content_species_mapping",
  "moisture_content_species_mapping_mean",
  "moisture_content_schwarzpappel",
  "moisture_content_schwarzpappel_mean",
];

export function getMoistureContentDisplayMode(userOrProfile) {
  return (
    userOrProfile?.moisture_content_display_mode ||
    userOrProfile?.profile?.moisture_content_display_mode ||
    "fraction"
  );
}

export function getMoistureContentCapEnabled(userOrProfile) {
  return (
    userOrProfile?.moisture_content_cap_enabled ??
    userOrProfile?.profile?.moisture_content_cap_enabled ??
    true
  );
}

export function scaleMoistureContentForDisplay(value, mode = "fraction", cap = true) {
  if (value == null || value === "") return value;
  const num = Number(value);
  if (!Number.isFinite(num)) return value;
  const clamped = cap ? Math.min(1, Math.max(0, num)) : num;
  return mode === "percent" ? clamped * 100 : clamped;
}

export function scaleMoistureThresholdForDisplay(value, mode = "fraction", cap = true) {
  if (value == null || value === "") return value;
  const num = Number(value);
  if (!Number.isFinite(num)) return value;
  const capped = cap ? Math.min(100, num) : num;
  return mode === "fraction" ? capped / 100 : capped;
}

export function scaleMoistureContentFields(rowOrObject, mode = "fraction", cap = true) {
  const result = { ...rowOrObject };
  for (const field of MOISTURE_CONTENT_FIELDS) {
    if (field in result) {
      result[field] = scaleMoistureContentForDisplay(result[field], mode, cap);
    }
  }
  return result;
}
